import type { WorkCalendar } from "./calendar";
import type { ISODate, ScheduledTask } from "./types";

/**
 * - done: 100% complete — nothing remains, never shown as negative
 * - upcoming: status date before start — working days until finish
 * - active: started and on or before finish — working days until finish (≥ 0)
 * - overdue: past finish and not complete — negative working days late
 */
export type RemainingKind = "done" | "upcoming" | "active" | "overdue";

export interface RemainingInfo {
  kind: RemainingKind;
  /** working days from the status date to finish; 0 when done */
  days: number;
}

export function remainingInfo(sched: Pick<ScheduledTask, "start" | "finish" | "percentComplete">, statusDate: ISODate, calendar: WorkCalendar): RemainingInfo {
  if (sched.percentComplete >= 100) return { kind: "done", days: 0 };
  const days = calendar.remainingWorkingDays(statusDate, sched.finish);
  if (days < 0) return { kind: "overdue", days };
  return { kind: statusDate < sched.start ? "upcoming" : "active", days };
}

export function formatRemaining(info: RemainingInfo): string {
  return info.kind === "done" ? "" : `${info.days}d`;
}
